export function translate(key, values) {
  var _useNuxtApp = useNuxtApp(),
    $i18n = _useNuxtApp.$i18n;
  return $i18n.t(key, values);
}
export function getLocale() {
  var _useNuxtApp2 = useNuxtApp(),
    $i18n = _useNuxtApp2.$i18n;
  var locale = $i18n.locale;
  if (locale === 'en-US') {
    locale = 'en';
  } else if (locale === 'de-DE') {
    locale = 'de';
  }
  return locale;
}